module.exports = __webpack_public_path__ + "img/expand-orange.ce00c6b2.svg";